import { render, staticRenderFns } from "./o-recaptcha-minimal.vue?vue&type=template&id=56cca6cd&"
import script from "./o-recaptcha-minimal.vue?vue&type=script&lang=js&"
export * from "./o-recaptcha-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports